// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1zOh5","containerItemsCenter":"Skeleton_containerItemsCenter__Tbcii"};